module.exports = __webpack_public_path__ + "media/images/logo-wordmark-dark-c08436559a39b9316a845565d3dcb9b8.svg";